import { Button, Heading, Input, InputNumber } from "@RooUI";
import React from "react";

import { FormContainer, FormFieldTwoColumnGrid, FormFields, FormHeader } from "../Common/styles";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useFormContext } from "./RegistrationEducationFormContext";

export const RegistrationEducationForm = () => {
  const {
    onChange,
    onSave,
    loading,
    errors,
    // @ts-expect-error TS2339
    form: { school, yearsOfPractice },
  } = useFormContext();

  return (
    <FormContainer>
      <FormHeader>
        <Heading level={3}>Where did you go to school?</Heading>
      </FormHeader>
      <FormFields>
        <FormFieldTwoColumnGrid>
          <Input
            label="School"
            value={school}
            // @ts-expect-error TS18048
            error={errors["school"]}
            // @ts-expect-error TS2722
            onChange={(e) => onChange("school", e.target.value)}
            name="vetSchool"
          />
          <InputNumber
            label="Total years as Tech/Assistant"
            inputMode="numeric"
            value={yearsOfPractice}
            // @ts-expect-error TS18048
            error={errors["yearsOfPractice"]}
            // @ts-expect-error TS2722
            onChange={(v: number) => onChange("yearsOfPractice", v)}
            id="yearsOfPractice"
          />
        </FormFieldTwoColumnGrid>
      </FormFields>
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title="Finish"
          onClick={onSave}
          loading={loading}
          data-testid="educationContinue"
        />
      </ButtonContainer>
    </FormContainer>
  );
};
